const currenyFormat = (value) => {

  // console.log('curreny format', value);
  if (isNaN(value)) {
    return "";
  }

  if (value >= 10000000) {
    return "₹ " + (value / 10000000).toFixed(2) + " Cr";
  } else if (value >= 100000) {
    return "₹ " + (value / 100000).toFixed(2) + " L";
  } else {
    return "₹ " + new Intl.NumberFormat("en-IN").format(value) 
  }
};

export default currenyFormat;
